import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import MainMenu from "../../components/MainMenu";
import AnnouncementsCard from "../../components/DashboardComponents/AnnouncementsCard/AnnouncementsCard";
import NewsCard from "../../components/DashboardComponents/NewsCard/NewsCard";
import HandicapCard from "../../components/DashboardComponents/HandicapCard/HandicapCard";
import CalendarCard from "../../components/DashboardComponents/CalendarCard/CalendarCard";
import LeaderboardCard from "../../components/DashboardComponents/LeaderboardCard/LeaderboardCard";
import StandingsCard from "../../components/DashboardComponents/StandingsCard/StandingsCard";
import SponsorsCard from "../../components/DashboardComponents/SponsorsCard/SponsorsCard";
import Snackbar from "@mui/material/Snackbar";
import {
  getDashboardAnnouncements,
  getDashboardSponsors,
  getDashboardNews,
  getDashboardCalender,
  getLatestTournamentLeaderboard,
  getLatestCombinedLeaderboard,
} from "../../redux/actions/dashboard-action";
import { getUserDetails } from "../../redux/actions/user-action";
import { useDispatch, useSelector } from "react-redux";
import { NewsAdsDialog, AnnoucementAdsDialog } from "../../components";
import "./Dashboard.css";
import SkeletonLoading from "../../components/SkeletonLoading";

const dashboardMinSizeMessage = `Please switch to a screen with resolution higher than 1464px for best experience`;

function Dashboard() {
  const dispatch = useDispatch();

  const [announcementModal, setAnnouncementModal] = useState(false);
  const [newsModal, setNewsModal] = useState(false);

  const announcementData = useSelector(
    (state) => state?.dashboardAnnouncementsReducer?.data?.announcement[0]
  );
  const loadingAnnouncement = useSelector(
    (state) => state.dashboardAnnouncementsReducer.loading
  );

  const newsData = useSelector(
    (state) => state?.dashboardNewsReducer?.data?.news[0]
  );
  const newsLoading = useSelector(
    (state) => state.dashboardNewsReducer.loading
  );

  const userInfo = useSelector((state) => state?.userDetailsReducer?.data);
  const userInfoLoading = useSelector(
    (state) => state?.userDetailsReducer.loading
  );

  const calenderEventsData = useSelector(
    (state) => state?.dashboardCalenderReducer?.data?.upcoming_matches
  );
  const calendarLoading = useSelector(
    (state) => state.dashboardCalenderReducer.loading
  );

  const sponsorsList = useSelector(
    (state) => state?.dashboardSponsorsReducer?.data?.sponsors
  );

  const sponsorsListLoading = useSelector(
    (state) => state?.dashboardSponsorsReducer.loading
  );

  const latestPoty = useSelector(
    (state) => state?.dashboardLatestPotyReducer?.data
  );
  const latestPotyLoading = useSelector(
    (state) => state.dashboardLatestPotyReducer.loading
  );

  const combineLeaderboard = useSelector(
    (state) => state?.dashboardCombineLeaderboardReducer?.data
  );
  const combineLeaderboardLoading = useSelector(
    (state) => state?.dashboardCombineLeaderboardReducer.loading
  );

  const [snackStateOpen, setSnackState] = React.useState(false);

  useEffect(() => {
    dispatch(getDashboardAnnouncements());
    dispatch(getDashboardSponsors());
    dispatch(getDashboardAnnouncements());
    dispatch(getDashboardNews());
    dispatch(getDashboardCalender());
    dispatch(getUserDetails());
    dispatch(getLatestTournamentLeaderboard());
    dispatch(getLatestCombinedLeaderboard());
  }, []);

  return (
    <MainMenu>
      <NewsAdsDialog
        newsData={newsData}
        open={newsModal}
        setOpen={setNewsModal}
      />
      <AnnoucementAdsDialog
        announcementData={announcementData}
        open={announcementModal}
        setOpen={setAnnouncementModal}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackStateOpen}
        onClose={() => setSnackState(false)}
        message={dashboardMinSizeMessage}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} lg={4}>
          <Grid container rowGap={2}>
            {newsLoading ? (
              <SkeletonLoading height={300} />
            ) : (
              <NewsCard
                newsData={newsData}
                open={newsModal}
                setOpen={setNewsModal}
              />
            )}
            {calendarLoading ? (
              <SkeletonLoading height={200} />
            ) : (
              <CalendarCard calenderEventsData={calenderEventsData} />
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Grid container rowGap={2}>
            {loadingAnnouncement ? (
              <SkeletonLoading height={200} />
            ) : (
              <AnnouncementsCard
                announcementData={announcementData}
                open={announcementModal}
                setOpen={setAnnouncementModal}
              />
            )}
            {sponsorsListLoading ? (
              <SkeletonLoading height={200} />
            ) : (
              <SponsorsCard sponsorsList={sponsorsList} />
            )}
            {combineLeaderboardLoading ? (
              <SkeletonLoading height={300} />
            ) : (
              <StandingsCard potyData={combineLeaderboard} />
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Grid container rowGap={2}>
            {userInfoLoading ? (
              <SkeletonLoading height={500} />
            ) : (
              <HandicapCard userInfo={userInfo} />
            )}
            {latestPotyLoading ? (
              <SkeletonLoading height={200} />
            ) : (
              <LeaderboardCard leaderboard={latestPoty} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </MainMenu>
  );
}

export default Dashboard;
